<template>
	<div>
		<ValidationObserver
			ref="abandonOptout"
			v-slot="{ invalid, errors }"
			class="sign-in"
			tag="form"
			@submit.prevent="onAbandonOptout"
			novalidate
		>
			<h2 v-html="$t('abandon.title')" v-if="!hideTitle"/>

			<GeneralMessage
				v-if="abandonOptoutResponse.message"
				:message="abandonOptoutResponse.message"
				:type="abandonOptoutResponse.type"
				@close="abandonOptoutResponse.message = ''"
			/>

			<ValidationProvider
				class="form-row__wrapper"
				name="token"
				rules="required"
				v-slot="{ errors, invalid, validated, dirty }"
				tag="div"
				:customMessages="{ required: $t('forms.errors.fieldEmpty') }"
			>
				<FormInput
					type="text"
					:placeholder="$t('abandon.tokenLabel')"
					:label="$t('abandon.tokenLabel')"
					v-model="abandonOptout.token"
					:error="invalid && validated"
					:error-message="errors[0]"
					:disabled="disabled"
					required
				/>
			</ValidationProvider>

			<Button
				type="submit"
				level="primary"
				:text="$t('abandon.optoutButton')"
				:disabled="disabled"
			/>
		</ValidationObserver>
	</div>
</template>

<script>
import Vue from "vue"
import GenericMixin from '@/mixins/GenericVueMixin';
import { mapGetters } from "vuex"
import { ValidationProvider, ValidationObserver } from "vee-validate"
import FormInput from "@/components/FormInput"
import Button from '@/components/Button'
import GeneralMessage from '@/components/GeneralMessage'
import { getUrlParams } from '@/utils/urlParams';

export default {
	mixins: [
		GenericMixin,
	],
	components: {
		ValidationProvider,
		ValidationObserver,
		FormInput,
		Button,
		GeneralMessage,
	},
	props: {
		hideTitle: Boolean,
		phone: {
			type: Boolean,
			default: false,
		},
		confirm: {
			type: String,
			default: '',
		}
	},
	data() {
		return {
			abandonOptout: {
				token: '',
			},
			confirmUrl: this.$root.options.confirmUrl || this.confirm,
			abandonOptoutResponse: {
				type: 'info',
				message: '',
			},
		}
	},
	computed: {
		...mapGetters("account", [
			"isLoggedIn"
		]),
		...mapGetters('loader', [
			'isLoading',
		]),
		loading: {
			set(value) {
				this.$store.dispatch('loader/setLoading', value);
				this.$emit('loading', value);
			},
			get() {
				return this.isLoading;
			}
		},
		disabled() {
			return !!this.isLoggedIn || this.loading;
		},
	},
	methods: {
		async onAbandonOptout() {
			const isValid = await this.$refs.abandonOptout.validate()
			if (isValid) {
				this.loading = true;
				document.activeElement.blur();
				try {
					const response = await this.$store.dispatch('account/abandonOptout', this.abandonOptout)
					if (response.redirect && response.redirect.key) {
						return this.$store.dispatch('redirect', {
							name: response.redirect.key,
							params: response.redirect.params || {},
						})
					}
					this.resetForm();
					// this.abandonOptoutResponse.message = this.$t('login.successRegister');
					// this.abandonOptoutResponse.type = 'success';
					this.$emit('confirmed');
					return this.$store.dispatch('redirect', {
						name: 'custom',
						url: this.confirmUrl
					})
				} catch(err) {
					let message = this.$t('forms.errors.generic')
					const data = err.response.data;

					if (data) {
						if (data.redirect && data.redirect.key) {
							return this.$store.dispatch('redirect', {
								name: data.redirect.key,
								params: data.redirect.params || {},
							})
						}

						if (data.message || data.errors) {
							message = data.errors && Object.values(data.errors).length
								? Object.values(data.errors).flat().join()
								: data.message
						} else {
							message = this.$t('forms.errors.generic');
						}
					}

					this.abandonOptoutResponse.message = message;
					this.abandonOptoutResponse.type = 'error';
				}
				this.loading = false;
			}
		},
		resetForm(form, inputs = true) {
			try {
				if (!form || form === 'register') {
					if (inputs) {
						this.abandonOptout.token = '';
					}
					this.abandonOptoutResponse.message = '';
					this.$refs.abandonOptout.reset();
				}
				if (!form) {
					this.loading = false;
				}
				if (inputs) {
					document.activeElement.blur();
				}
			}
			catch(err) {}
		},
	},
	mounted() {
		const params = getUrlParams()
		this.abandonOptout.token = params.token
	}
}
</script>

<style>

</style>
